import { FilingShell } from './components/FilingShell';

export function FilingStatusPage() {
  return (
    <FilingShell title="Filing status">
      <div className="border border-dashed border-border bg-card p-8">
        <p className="font-medium">Status updates</p>
        <p className="mt-2 text-sm text-muted-foreground">
          Submission status and acknowledgements will appear here as filing activity is recorded.
        </p>
      </div>
    </FilingShell>
  );
}
